<!-- App root component -->
<template>
  <router-view />
</template>

<script setup>
//
</script>
